<input
    #autocompleteInput
    (keydown.escape)="escPress()"
    (keydown.enter)="enterPress()"
    (keydown.arrowUp)="prevItem($event)"
    (keydown.arrowDown)="nextItem($event)"
    (keydown.backspace)="backspacePress()"
    autocomplete="off"
    class="form-control field-input"
    name="q"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    type="text"
    [ngClass]="{'field-input-group field-search-browse input-group': buttonType === AUTOCOMPLETE_SEARCH_BUTTON_TYPES.ICON_BROWSE, 'is-invalid': isInvalid,
        'btn btn-secondary style-underline': buttonText !== ''}"
    (blur)="handleBlur()"
    (focus)="handleFocus()"/>
<div *ngIf="includeSearchIcon" class="field-input-group-actions">
    <div class="btn btn-transparent">
        <svg ycnIcon [name]="'icon-search'"></svg>
    </div>
</div>

<!-- submit button -->
<ng-container *ngIf="!hideButton">
    <div *ngIf="buttonType === AUTOCOMPLETE_SEARCH_BUTTON_TYPES.ICON_SEARCH" class="field-input-group-actions">
        <button class="btn btn-transparent"
           type="button"
           tabindex="-1"
           aria-label="Search"
           (click)="handleClick()"
           (mouseenter)="setShouldBlur(false)"
           (mouseleave)="setShouldBlur(true)">
            <svg ycnIcon [name]="buttonType" aria-hidden="true"></svg>
        </button>
    </div>
    <span *ngIf="buttonType === AUTOCOMPLETE_SEARCH_BUTTON_TYPES.ADD_BUTTON" class="input-group-btn">
        <div class="btn btn-secondary"
             tabindex="-1"
             ycnDisabled
             [disabled]="isDisabled"
             (click)="handleClick()"
             (mouseenter)="setShouldBlur(false)"
             (mouseleave)="setShouldBlur(true)">
            Add
        </div>
    </span>
    <span *ngIf="buttonType === AUTOCOMPLETE_SEARCH_BUTTON_TYPES.ICON_BROWSE">
        <div class="btn btn-secondary btn-browse"
             tabindex="-1"
             (click)="handleClick()"
             (mousedown)="setShouldBlur(false)"
             (mouseup)="setShouldBlur(true)">
             <svg ycnIcon [name]="buttonType"></svg>
             <span *ngIf="buttonText" [innerText]="buttonText"></span>
        </div>
    </span>
</ng-container>
